import React from "react";
import { connect } from "react-redux";
import useCustomImagesConfig from "../../hooks/useCustomImagesConfig";

const ClientPhotosInfo = (props) => {
    const { clientPhotosSettings } = useCustomImagesConfig(
        props.account,
        props.designatedDescriptionResponse
    );

    if (clientPhotosSettings) {
        const { captionedPhotoDescription, captionedPhotoItems, additionalPhotosDescription } = clientPhotosSettings;

        return (
            <div className="client-photos-info pb-3">
                <div className="client-photos-header p-2 h3">
                    <i className="icon prism-icon-info" style={{ marginRight: "5px" }} />
                    <span className="font-weight-bold">Client Photos</span>
                </div>
                <div className="client-photos-list">
                    <ul className="client-photos-bullets">
                        {captionedPhotoDescription && (
                            <li className="font-weight-bold">
                                {captionedPhotoDescription}
                                {captionedPhotoItems.length > 0 && (
                                    <ul className="client-photos-sub-bullets">
                                        {captionedPhotoItems.map((item, index) => (
                                            <li className="font-weight-lighter" key={index}>{item}</li>
                                        ))}
                                    </ul>
                                )}
                            </li>
                        )}
                        {additionalPhotosDescription.length > 0 &&
                            additionalPhotosDescription.map((photo, index) => (
                                <li className="font-weight-bold" key={index}>{photo}</li>
                            ))}
                    </ul>
                </div>
            </div>
        );
    }

    return null;
};

function mapStateToProps({ designatedDescriptionResponse, account }) {
    return { designatedDescriptionResponse, account };
}

export default connect(mapStateToProps)(ClientPhotosInfo);